import React from "react";
import {
  ExclamationTriangleIcon,
  HomeIcon,
  ArrowLeftIcon,
  MagnifyingGlassCircleIcon,
} from "@heroicons/react/24/outline";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-base-200 to-base-100 flex items-center justify-center p-4">
      <div className="card max-w-2xl  shadow-2xl">
        <div className="card-body items-center text-center p-8">
          <div className="relative">
            <h1 className="font-bold text-9xl text-primary opacity-10">404</h1>
            <div className="absolute inset-0 flex items-center justify-center">
              <ExclamationTriangleIcon className="w-16 h-16 text-warning animate-bounce" />
            </div>
          </div>
          <div className="mt-4 space-y-3">
            <h2 className="text-2xl font-bold text-base-content">
              Oops! Trang không tồn tại
            </h2>
            <p className="text-base-content/70 max-w-md">
              Có vẻ như trang bạn đang tìm kiếm không tồn tại hoặc đã bị di
              chuyển đến một địa chỉ khác.
            </p>
          </div>

          <div className="my-8 relative">
            <MagnifyingGlassCircleIcon className="w-24 h-24 text-primary/20 animate-[spin_5s_linear_infinite]" />
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-2xl">?</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 mt-4">
            <button
              onClick={() => (window.location.href = "/")}
              className="btn btn-primary gap-2 hover:scale-105 transition-transform"
            >
              <HomeIcon className="w-5 h-5" />
              Trang chủ
            </button>
            <button
              onClick={() => window.history.back()}
              className="btn btn-outline gap-2 hover:bg-base-200 transition-colors"
            >
              <ArrowLeftIcon className="w-5 h-5" />
              Quay lại
            </button>
          </div>

          <div className="mt-8 text-sm text-base-content/60">
            <p>Bạn có thể thử:</p>
            <ul className="mt-2 space-y-1">
              <li>• Kiểm tra lại đường dẫn URL</li>
              <li>• Làm mới trang</li>
              <li>• Quay lại trang trước</li>
            </ul>
          </div>

          <div className="mt-8 pt-6 border-t border-base-200 w-full">
            <p className="text-sm text-base-content/50">
              Nếu bạn cho rằng đây là lỗi, vui lòng{" "}
              <a href="/lien-he" className="text-primary hover:underline">
                liên hệ với chúng tôi
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
